<template>
  <div class="classifyFormShell">
    <el-card class="card linkFormSection" data-section-id="basic">
      <div slot="header" class="linkFormSection__header">
        <strong class="linkFormSection__title">基本信息</strong>
      </div>

      <div class="linkFormBasic">
        <div class="linkFormBasic__media">
          <div class="linkFormMediaAnchor">
            <el-image
              v-if="ruleForm.backgroundUrl"
              class="linkFormMediaAnchor__preview"
              :src="ruleForm.backgroundUrl"
              :preview-src-list="[ruleForm.backgroundUrl]"
              fit="cover"
            >
              <div slot="error" class="linkFormMediaAnchor__previewFallback">
                <i class="el-icon-picture-outline" aria-hidden="true" />
              </div>
            </el-image>
            <button
              v-else
              type="button"
              class="linkFormUploadZone linkFormUploadZone--anchor"
              :disabled="uploadLoading"
              @click="triggerCoverUpload"
            >
              <i class="el-icon-upload2 linkFormUploadZone__icon" aria-hidden="true" />
              <span>上传封面</span>
              <span class="linkFormUploadZone__hint">支持 .jpg / .png / .webp</span>
            </button>
          </div>

          <div
            v-if="ruleForm.backgroundUrl"
            class="linkFormMediaFileBar"
          >
            <span class="linkFormMediaFileBar__name" :title="ruleForm.backgroundName">
              {{ ruleForm.backgroundName || '封面图' }}
            </span>
            <div class="linkFormMediaFileBar__actions">
              <button
                type="button"
                class="linkFormMediaFileBar__btn"
                :disabled="uploadLoading"
                @click="triggerCoverUpload"
              >
                替换
              </button>
              <button
                type="button"
                class="linkFormMediaFileBar__btn linkFormMediaFileBar__btn--danger"
                @click="clearCover"
              >
                移除
              </button>
            </div>
          </div>

          <el-upload
            ref="coverUpload"
            class="classifyCoverUploadHidden"
            action="111"
            accept=".jpg,.jpeg,.png,.webp"
            :http-request="onCoverUpload"
            :show-file-list="false"
          />

          <el-form-item prop="backgroundUrl" class="linkFormBasic__urlField">
            <el-input v-show="false" v-model="ruleForm.backgroundUrl" />
          </el-form-item>
        </div>

        <div class="linkFormBasic__fields">
          <div class="linkFormBasic__meta">
            <el-form-item label="分类名称" prop="name" class="linkFormBasic__nameField">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入分类名称"
              />
            </el-form-item>

            <div v-if="!isCreate && ruleForm.key" class="linkFormBasic__keyRow">
              <span class="linkFormBasic__keyLabel">Key</span>
              <code class="linkFormBasic__keyValue link-font-mono" :title="ruleForm.key">
                {{ displayKey }}
              </code>
              <button type="button" class="linkFormBasic__copyBtn" @click="copyKey">
                复制
              </button>
            </div>
          </div>

          <el-form-item v-if="showTypeField" label="分类类型" prop="type">
            <el-select
              v-model="ruleForm.type"
              placeholder="请选择分类类型"
              class="formItemStyle"
              popper-class="linkListFilterDropdown"
              :disabled="!isCreate"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.categoryType"
                :label="item.name"
                :value="item.categoryType"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="分类 Title" prop="title">
            <el-input
              v-model="ruleForm.title"
              placeholder="请输入分类 Title"
            />
          </el-form-item>
        </div>
      </div>
    </el-card>

    <filter-classify-card
      :country="ruleForm.country"
      :iosVersion="ruleForm.iosVersion"
      :androidVersion="ruleForm.androidVersion"
      :appVersion.sync="ruleForm.appVersion"
      :dataOptions="dataOptions"
    />

    <el-card class="card linkFormSection">
      <div slot="header" class="linkFormSection__header">
        <strong class="linkFormSection__title">其他</strong>
      </div>
      <el-form-item label="备注（选填）">
        <el-input
          v-model="ruleForm.comment"
          type="textarea"
          placeholder="运营备注，列表筛选用「备注」字段模糊搜索"
          :rows="3"
        />
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import filterClassifyCard from '../../../components/filterClassifyCard.vue'

export default {
  name: 'ClassifyFormShell',
  components: {
    filterClassifyCard,
  },
  props: {
    ruleForm: { type: Object, required: true },
    isCreate: { type: Boolean, default: true },
    typeOptions: { type: Array, default: () => [] },
    dataOptions: { type: Array, default: () => [] },
    uploadLoading: { type: Boolean, default: false },
    showTypeField: { type: Boolean, default: true },
  },
  computed: {
    displayKey() {
      const key = this.ruleForm.key
      if (!key) {
        return '—'
      }
      if (key.length <= 36) {
        return key
      }
      return `${key.slice(0, 16)}…${key.slice(-12)}`
    },
  },
  methods: {
    triggerCoverUpload() {
      const upload = this.$refs.coverUpload
      if (upload && upload.$refs['upload-inner']) {
        upload.$refs['upload-inner'].$refs.input.click()
      }
    },
    onCoverUpload(params) {
      this.$emit('cover-upload', params)
    },
    clearCover() {
      this.ruleForm.backgroundUrl = ''
      this.ruleForm.backgroundName = ''
      this.$emit('cover-cleared')
    },
    copyKey() {
      const key = this.ruleForm.key
      if (!key) {
        return
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(key).then(() => {
          this.$message.success('Key 已复制')
        })
        return
      }
      this.$message.warning('当前环境不支持自动复制')
    },
  },
}
</script>

<style scoped>
.classifyFormShell {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.formItemStyle {
  width: 100%;
}

.classifyCoverUploadHidden {
  display: none;
}

/*
 * 分类表单字段较少，右侧列比默认 200×200 上传锚点更高；
 * 让左侧媒体列随 grid 行拉伸，上传/预览区占满剩余高度。
 */
.classifyFormShell >>> .linkFormBasic {
  align-items: stretch;
}

.classifyFormShell >>> .linkFormBasic__media {
  display: flex;
  flex-direction: column;
  align-self: stretch;
}

.classifyFormShell >>> .linkFormMediaAnchor {
  flex: 1 1 auto;
  width: 200px;
  height: auto;
  min-height: 200px;
}

.classifyFormShell >>> .linkFormMediaAnchor__preview {
  width: 100%;
  height: 100%;
}

.classifyFormShell >>> .linkFormUploadZone--anchor {
  min-height: 100%;
}

.classifyFormShell >>> .linkFormBasic__urlField {
  display: none;
  margin: 0;
}

@media (max-width: 768px) {
  .classifyFormShell >>> .linkFormMediaAnchor {
    flex: none;
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
}
</style>
